import { initSwiper } from '../components/swiper';
import initCartUpsellAtc from '../components/cart-upsell-atc';

const RECOMMENDATIONS_LIMIT = 10;

const renderCartUpsellRecommendations = async (onAdded) => {
  const placeholderEl = document.querySelector('[data-cart-upsell-recommendations]');
  if (!placeholderEl) return;

  const { sectionId, productId, intent } = placeholderEl.dataset;
  if (!sectionId || !productId || !intent) return;

  try {
    const params = `section_id=${sectionId}&product_id=${productId}&limit=${RECOMMENDATIONS_LIMIT}&intent=${intent}`;
    const res = await fetch(`${window.Shopify.routes.root}recommendations/products?${params}`);
    if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
    const markup = await res.text();

    const parser = new DOMParser();
    const doc = parser.parseFromString(markup, 'text/html');
    const upsellEl = doc.querySelector('[data-cart-upsell]');
    if (!upsellEl) {
      placeholderEl.classList.add('hidden');
      return;
    }

    placeholderEl.innerHTML = upsellEl.outerHTML;
    placeholderEl.classList.remove('hidden');

    const sliderEl = placeholderEl.querySelector('[data-swiper]');
    if (sliderEl) initSwiper(sliderEl);
    initCartUpsellAtc(onAdded);
  } catch (e) {
    console.error('Failed to fetch cart recommendations:', e);
    placeholderEl.classList.add('hidden');
  }
};

export default renderCartUpsellRecommendations;
